/** @module Archiving/ViewArchivePdfController */
define([
    "dojo/_base/declare",
	"csi",
    "csi/comm",
	"csi/action/Controller",
	"csi/locale",
], function(declare, csi, comm, ActionController, locale) {

	return declare(ActionController, {
		process: function() {
			this.inherited(arguments);
			csi.browserWindow(comm.getFileHref(this.getNode().ArchivePDF, false, locale.getNodeName(this.getNode())));
		}
	});
});